"use client";

import React from "react";
import { Zap, Settings2, Lightbulb, Plug, Server, Wrench, ShieldCheck, BatteryCharging, Cpu } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Ground-Up Commercial & Industrial Construction",
  description: "Ground-Up Commercial & Industrial Construction — Complete electrical infrastructure for new commercial and industrial facilities, including service installation, distribution gear, branch power, lighting systems, equipment feeds, life-safety integration, and coordination with all trades from foundation to final inspection. ABCO South delivers code-tight, schedule-driven installations built for long-term reliability and future expansion.",
  icon: Cpu
}, {
  title: "Power Distribution",
  description: "Robust and reliable power distribution systems designed for heavy industrial and commercial applications and maximum uptime.",
  icon: Zap
}, {
  title: "Electrical Vehicle Chargers",
  description: "From workplace charging to high-speed DC fast chargers, ABCO South delivers turnkey Level 2 and Level 3 EV charging installations built for performance, safety, and dependable operation.",
  icon: Settings2
}, {
  title: "Industrial and Commercial Lighting",
  description: "Energy-efficient LED retrofits and comprehensive lighting design for manufacturing, warehouse, office, medical and retail facilities",
  icon: Lightbulb
}, {
  title: "Equipment Hookups",
  description: "Precision electrical connections for new manufacturing equipment, ensuring safe and compliant integration.",
  icon: Plug
}, {
  title: "Switchgear Upgrades",
  description: "Modernization of aging switchgear to enhance facility safety, capacity, and operational reliability.",
  icon: Server
}, {
  title: "Troubleshooting & Repair",
  description: "Rapid-response diagnostics and repair services to minimize downtime and restore critical operations.",
  icon: Wrench
}, {
  title: "Preventative Maintenance",
  description: "Preventative electrical maintenance services to enhance reliability, improve safety, and reduce unplanned outages across commercial and industrial facilities.",
  icon: ShieldCheck
}, {
  title: "Generator Installation",
  description: "Turnkey backup power solutions to keep your facility running during unexpected utility outages.\xA0",
  icon: BatteryCharging
}, {
  title: "Automation & PLC",
  description: "Automation Engineering and Consuluting, PLC Programming, Integration and Robotics Solutions.",
  icon: Cpu
}];
export default function CoreServicesGrid() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="coreservicesgrid" className="bg-foreground text-background py-20 md:py-32">
      <div ref={ref} className="container mx-auto px-4 md:px-6 max-w-7xl">
        
        <div className={`text-center mb-16 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold mb-6">Core Electrical Services</h2>
          <div className="w-24 h-1 bg-ring mx-auto rounded-lg"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6 md:gap-8">
          {services.map((service, i) => <Card key={i} data-index={i} className={`bg-transparent border border-muted-foreground/20 rounded-lg shadow-none hover:border-ring transition-all duration-500 text-background h-full group ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
          transitionDelay: `${i * 100}ms`
        }}>
              <CardHeader className="px-8 pt-8 pb-4">
                <service.icon className="w-10 h-10 mb-4 text-background group-hover:text-ring transition-colors duration-300" strokeWidth={1.5} />
                <CardTitle className="font-default text-xl font-bold tracking-wide">
                  {service.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="px-8 pb-8 pt-0">
                <p className="font-sans text-background/70 leading-relaxed text-sm md:text-base">
                  {service.description}
                </p>
              </CardContent>
            </Card>)}
        </div>

      </div>
    </section>;
}